export default {
  profile: {
    location: 'Madrid, España',
    linkedIn: 'Ir a LinkedIn',
    github: 'Ir a Github'
  },
  menu: {
    home: 'Inicio',
    projects: 'Proyectos',
    contact: 'Contacto'
  },
  experience: {
    title: 'Experiencia',
    developed: 'Proyectos desarrollados en',
    open: '¿Qué hice en {{company}}?',
    close: 'Cerrar información sobre {{company}}'
  },
  goTo: 'Ir a',
  education: {
    title: 'Educación'
  },
  languages: {
    title: 'Idiomas',
    change: 'Cambiar a inglés'
  },
  projects: {
    title: 'Mis Proyectos'
  }
};
